import React from "react";
import Section from "./components/Section";
import { demoData } from "./data/demo-data";
import "./App.scss";
import { isIE } from "react-device-detect";

const App = () => {
  if (isIE) {
    return (
      <div className="ms">
        <Section data={demoData.flows} />
      </div>
    );
  } else {
    return <Section data={demoData.flows} />;
  }
};

export default App;
